<template>
  <div class="flex gap-6 justify-between">
    <div
      v-for="i in 6"
      :key="i"
      class="bg-sky-500/20 animate-pulse w-24 h-12 rounded-full"
    ></div>
  </div>
</template>
